import { LabeledValue } from '../../../../../../core/components';
import styles from './libraryContentRow.module.scss';
import EventThumbnail from '../../../../../Event/EventThumbnail';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { memo, useMemo } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import theme from '../../../../../../theme';
import LibraryContentRowButtons from './components/LibraryContentRowButtons';

const mapStateToProps = (state) => ({
    isAdmin: state.user.currentUser.groups && state.user.currentUser.groups.includes('Admin')
});

const LibraryContentRow = ({ video, getPriceById, showBorder, isAdmin }) => {
    const { t } = useTranslation();
    const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));

    const formattedDate = useMemo(() => {
        return new Date(video.start_date).toISOString().split('T')[0];
    }, [video.start_date]);

    return (
        <>
            <div className={clsx(styles.leftSide, showBorder && styles.bottomBorder)}>
                <Link to={`/watch/${video.id}`}>
                    <EventThumbnail
                        borderRadius={'12px'}
                        event={video}
                        width={isTablet ? 70 : 200}
                        height={isTablet ? 70 : 100}
                    />
                </Link>
                <div className={styles.leftSideColumn}>
                    <Link to={`/watch/${video.id}`}>
                        <LabeledValue value={video.title} label={video.description} />
                    </Link>
                </div>
                {isAdmin && isTablet && <LibraryContentRowButtons videoId={video.id} />}

                <div className={styles.statistics}>
                    <div className={styles.leftSideColumn}>
                        <LabeledValue
                            value={getPriceById(video.pay_per_view_product)}
                            label={t('Price')}
                        />
                    </div>
                    <div className={styles.leftSideColumn}>
                        <LabeledValue value={video.streams} label={t('Streams')} />
                    </div>
                    <div className={styles.leftSideColumn}>
                        <LabeledValue value={formattedDate} label={t('Published')} />
                    </div>
                </div>
            </div>
            <div>{isAdmin && !isTablet && <LibraryContentRowButtons videoId={video.id} />}</div>
        </>
    );
};

export default connect(mapStateToProps, null)(memo(LibraryContentRow));
